import { MenuItem } from "react-ui";
import * as React from "react";
import ReactDOM from "react-dom";

import { ActionProps } from "../Common/ActionProps";
import { useActionClickHandler } from "../Common/handleActionClick";
import { Icon } from "../../Icons/Icon";
import { TestPageObjectHandle } from "../../Services/TestPageObjects/TestPageObjectHandle";
import { emptyRef } from "../../TypingUtils";
import { toHtmlElementOrNull } from "../../Commons/DOM/DomHelpers";

export const KebabAction = (props: ActionProps): JSX.Element => {
    const handleClick = useActionClickHandler(props);
    const kebabActionRef = React.useRef(emptyRef);

    const testPageObject = React.useMemo(
        () => ({
            getType: () => "KebabAction",
            click: () => {
                if (kebabActionRef.current == undefined) {
                    return false;
                }
                const element = toHtmlElementOrNull(ReactDOM.findDOMNode(kebabActionRef.current));
                if (element == undefined) {
                    return false;
                }
                element.click();
                return true;
            },
        }),
        [props, kebabActionRef.current]
    );

    return (
        <TestPageObjectHandle id={`${props.bindingPath?.toLegacyPath()}`} pageObject={testPageObject}>
            <MenuItem
                disabled={props.disabled}
                data-tid={props["data-tid"]}
                state={props.state}
                onMouseEnter={props.onMouseEnter}
                onMouseLeave={props.onMouseLeave}
                onClick={handleClick}
                icon={props.icon ? <Icon name={props.icon} /> : undefined}
                ref={kebabActionRef}>
                {props.children}
            </MenuItem>
        </TestPageObjectHandle>
    );
};
